// Import necessary modules
import render from './render/feed.render.index.js';
import filters from './filters/feed.filters.index.js';

// Set the global feed URL
global.feedUrl = gsfcLocalise.feed_url; // eslint-disable-line

/**
 * Initializes the feed rendering and filtering.
 */
async function init() {
	// Check if the feed element exists
	if (document.querySelector('.js-gsfc-feed')) {
		// Setup listeners and default filters
		await filters.init(renderCallback);
		// Initial render with default filters
		renderCallback(false, true);
	}
}

/**
 * Callback function for rendering.
 * @param {boolean} resetPage Indicates whether to reset the page number.
 * @param {boolean} firstLoad Indicates whether it's the first load.
 */
async function renderCallback(resetPage = true, firstLoad = false) {
	// Update filters as it's likely the filter state has changed
	filters.update(resetPage);
	// Process rendering
	render.process(firstLoad);
}

// Export the feed methods
export default { init };
